import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    children: [
      {
        path: 'zhaomu', 
        name:'zhaomu',
        component: () => import(/* webpackChunkName: "about" */ '../views/zhaomu.vue'),
      },
      {
        path: 'canping', 
        name:'canping',
        component: () => import(/* webpackChunkName: "about" */ '../views/canping.vue'),
      },
      {
        path: 'bangzhu', 
        name:'bangzhu',
        component: () => import(/* webpackChunkName: "about" */ '../views/bangzhu.vue'),
      },
      {
        path: 'bangzhulist', 
        name:'bangzhulist',
        component: () => import(/* webpackChunkName: "about" */ '../views/bangzhulist.vue'),
      }, 
      {
        path: 'sousuolist', 
        name:'sousuolist',
        component: () => import(/* webpackChunkName: "about" */ '../views/sousuolist.vue'),
      }, 
      {
        path: 'AboutUs', 
        name:'AboutUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue'),
      }, 
      {
        path: 'bangzhudet', 
        name:'bangzhudet',
        component: () => import(/* webpackChunkName: "about" */ '../views/bangzhudet.vue'),
      }, 
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
